import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './browseideaspage.cssmodule.scss';
import CreateIdeasHeader from '../Shared/CreateIdeasHeader';
import {Panel, FormControl, Button, Nav, NavItem, NavDropdown, MenuItem} from 'react-bootstrap';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';
import {INITIATIVE_TYPE, CIP_TYPE} from '../../constants';
import InitiativeTable from './InitiativeTable';
import CipIdeaTable from './CipIdeaTable';
import { Link } from 'react-router';


class BrowseIdeasPage extends React.Component {


  constructor(props) {
    super(props);
    const {ideaType } = this.props;
    this.state = {ideaType : ideaType , pageSize : 50};
  }

  componentDidMount() {
    const { ideaType } = this.props;
    const { actions } = this.props;
    const { myOwnIdea } = this.props;
    const { initiativeFilter } = this.props;

    // Parse filters from the URL
    const queryParams = new URLSearchParams(window.location.search);
    const filters = Object.fromEntries(queryParams.entries());

    if (ideaType == CIP_TYPE) {
      let pageIndx = this.props.cipIdeaPage.PageIndex || 1;
      actions.fetchCipIdeasAction(pageIndx, this.state.pageSize, { ...filters, MyOwn: myOwnIdea });
      actions.fetchCipGroupsAction();
    } else {
      let pageIndx = initiativeFilter.pageIndex || 1;
      const filter = { ...initiativeFilter, ...filters, MyOwn: myOwnIdea };
      actions.fetchInitiatives(pageIndx, this.state.pageSize, filter);
      actions.fetchInitiativeTypesAction();
    }

    this.setState({ ideaType: ideaType });
  }

  componentWillReceiveProps(nextProps) { 
    const {ideaType } = nextProps;
    const {actions } = nextProps;
    const {myOwnIdea } = this.props;

    if(ideaType != this.state.ideaType){
      if(ideaType == CIP_TYPE){
        actions.fetchCipIdeasAction(1, this.state.pageSize, {MyOwn : myOwnIdea});
        actions.fetchCipGroupsAction();
      }else{
        actions.fetchInitiatives(1, this.state.pageSize, {MyOwn : myOwnIdea});
        actions.fetchInitiativeTypesAction();
      }
    }
    this.setState( {ideaType : ideaType});
  }
  
  loadNextCipPage(filter){
    
    const {cipIdeaPage } = this.props;
    const {actions } = this.props;
    const {myOwnIdea } = this.props;
    filter.MyOwn = myOwnIdea;
    if(cipIdeaPage.PageIndex < cipIdeaPage.TotalPageCount){
      actions.fetchCipIdeasAction(cipIdeaPage.PageIndex + 1, this.state.pageSize, filter);
    }
  }

  

  loadPrevCipPage(filter){
    const {cipIdeaPage } = this.props;
    const {actions } = this.props;
    const {myOwnIdea } = this.props;
    filter.MyOwn = myOwnIdea;
    if(cipIdeaPage.PageIndex > 1){
      actions.fetchCipIdeasAction(cipIdeaPage.PageIndex - 1, this.state.pageSize, filter);
    }
  }


  loadNextInitiativePage(filter){
    const {initiativePage } = this.props;
    const {actions } = this.props;
    const {myOwnIdea } = this.props;
    filter.MyOwn = myOwnIdea;
    if(initiativePage.PageIndex < initiativePage.TotalPageCount){
      const nextPage = initiativePage.PageIndex + 1;
      actions.setInitiativeFilter({ ...filter, pageIndex: nextPage });
      actions.fetchInitiatives(nextPage, this.state.pageSize, filter);
    }
  }

  

  loadPrevInitiativePage(filter){
    const {initiativePage } = this.props;
    const {actions } = this.props;
    const {myOwnIdea } = this.props;
    filter.MyOwn = myOwnIdea;
    if(initiativePage.PageIndex > 1){
      const prevPage = initiativePage.PageIndex - 1;
      actions.setInitiativeFilter({ ...filter, pageIndex: prevPage });
      actions.fetchInitiatives(prevPage, this.state.pageSize, filter);
    }
  }

  applyCIPFilter(filter) {
    const { actions } = this.props;
    const { myOwnIdea } = this.props;
    filter.MyOwn = myOwnIdea;

    // Update the URL with the filter values
    const queryParams = new URLSearchParams(filter).toString();
    const newUrl = `/browse-ideas/2?${queryParams}`;
    window.history.pushState(null, '', newUrl);

    actions.fetchCipIdeasAction(1, this.state.pageSize, filter);
  }

  applyInitiativeFilter(filter) {
    const { actions } = this.props;
    const { myOwnIdea } = this.props;
    filter.MyOwn = myOwnIdea;

    // Update the URL with the filter values
    const queryParams = new URLSearchParams(filter).toString();
    const newUrl = `/browse-ideas/1?${queryParams}`;
    window.history.pushState(null, '', newUrl);

    actions.setInitiativeFilter({ ...filter, pageIndex: 1 });
    actions.fetchInitiatives(1, this.state.pageSize, filter);
  }

  handleSelect(eventKey) {
    event.preventDefault();
  }
  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };

    const {ideaType } = this.state;
    const {actions } = this.props;
    const {cipIdeaPage } = this.props;
    const { cipGroups } = this.props;
    const { initiativePage } = this.props;

    const { initiativeTypes } = this.props;
    const  { myOwnIdea } = this.props;
    const  { authInfo } = this.props;
    const  { locale } = this.props;
    const  { initiativeFilter } = this.props;
    

    initiativePage.Data.forEach((ini) => {
      if(ini.Type){
        let itype = ini.Type;
        if(locale == 'en'){
          itype.label = itype.TitleEN ? itype.TitleEN : itype.Title; 
        }
        else if(locale == 'sv'){
          itype.label = itype.TitleSV ? itype.TitleSV : itype.Title; 
        }else{
          itype.label = itype.Title; 
        }
      }
    });
    
    initiativeTypes.Types.forEach((itype) => {
      if(locale == 'en'){
          itype.label = itype.TitleEN ? itype.TitleEN : itype.Title; 
      }
      else if(locale == 'sv'){
        itype.label = itype.TitleSV ? itype.TitleSV : itype.Title; 
      }
      else{
        itype.label = itype.Title;
      }
    });
    
    return (
       <div className="container" styleName="browseideaspage-component" >
        <CreateIdeasHeader />
        <div className="row">
          <div className="col-md-12" styleName="browseideaspage-nav-tab">
              <ul className="nav nav-tabs nav-tabs-pivot">
                <li role="presentation" className={ideaType == INITIATIVE_TYPE ? 'active' : ''}><Link  to={myOwnIdea ? '/manage-ideas/1': '/browse-ideas/1'}>{ t('Initiatives')} </Link></li>
                <li role="presentation" className={ideaType == CIP_TYPE ? 'active' : ''}><Link to={myOwnIdea ? '/manage-ideas/2': '/browse-ideas/2'}>{ t('CIP_FULL')}</Link></li>
              </ul>
          </div>
        </div>
         <div className="row">
          <div className="col-md-12">
           {
              ideaType == CIP_TYPE ? 
                    (<CipIdeaTable  authInfo={authInfo} cipIdeaPage={cipIdeaPage} cipGroups={cipGroups} filterChanged={this.applyCIPFilter.bind(this)} loadPrevPage={this.loadPrevCipPage.bind(this)} loadNextPage={this.loadNextCipPage.bind(this)}/>): 
                    (<InitiativeTable authInfo={authInfo} initiativeTypes={initiativeTypes} filterChanged={this.applyInitiativeFilter.bind(this)}  initiativePage={initiativePage} loadPrevPage={this.loadPrevInitiativePage.bind(this)} loadNextPage={this.loadNextInitiativePage.bind(this)} storedFilter={initiativeFilter}/>)
           }
          </div>
        
        </div>
      </div>
    );
  }
}

BrowseIdeasPage.displayName = 'BrowseIdeasPage';
BrowseIdeasPage.propTypes = {};
BrowseIdeasPage.defaultProps = {};

export default injectIntl(cssmodules(BrowseIdeasPage, styles));



// WEBPACK FOOTER //
// ./components/BrowseIdeas/BrowseIdeasPage.js